export default __webpack_public_path__ + "static/media/chassi-coupon-autolink-example.eebfed73.png";